module.exports = __webpack_public_path__ + "img/MO.0dc09f49.svg";